<div class="table-container">
  <form class="table-filter">
    <div>
      <!-- <span class="table-filter-row">
        <div class="table-filter-title">Mostrar: </div>
        <select class="form-control" id="qtdPorPagina" name="qtdPorPagina" [(ngModel)]="qtdPorPagina">
          <option value="30" selected="true">30</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        <div class="table-filter-title">registros</div>
      </span> -->
    </div>
    <!-- <div class="col-md-6 form-group table-filter-row">
      <div class="table-filter-title">Procurar</div>
      <input
        maxlength="100"
        type="search"
        class="form-control"
        [(ngModel)]="procurarItem"
        name="procurarItem"
        (keyup)="onKeyupProcurarItem()"
      />
    </div> -->
  </form>

  <table class="table table-striped" aria-hidden="true"  aria-describedby="Listagem de propostas">
    <thead>
      <tr>
        <td>
          <app-header-sort
            description="PROD."
            column="grupo2"
            [current]="currentSort"
            (sort)="currentSort.next($event)"
          ></app-header-sort>
        </td>
        <td>
          <app-header-sort
            description="STATUS"
            [column]="'propostaHome.rastreio.status.descricao'"
            [current]="currentSort"
            (sort)="currentSort.next($event)"
          ></app-header-sort>
        </td>
        <td>
          <app-header-sort
            description="FICHA"
            column="id"
            [current]="currentSort"
            (sort)="currentSort.next($event)"
          ></app-header-sort>
        </td>
        <td>
          <app-header-sort
            description="CLIENTE"
            [column]="'propostaHome.cpfCliente'"
            [current]="currentSort"
            (sort)="currentSort.next($event)"
          ></app-header-sort>
        </td>
        <td>
          <app-header-sort
            description="VALOR"
            column="valorLiquido"
            [current]="currentSort"
            (sort)="currentSort.next($event)"
          ></app-header-sort>
        </td>
        <td>
          <app-header-sort
            description="ANALISTA"
            [column]="'propostaHome.rastreio.usuarioAcao'"
            [current]="currentSort"
            (sort)="currentSort.next($event)"
          ></app-header-sort>
        </td>
        <td>
          <app-header-sort
            description="DATA"
            column="dataInclusao"
            [current]="currentSort"
            (sort)="currentSort.next($event)"
          ></app-header-sort>
        </td>
        <td>
          <app-header-sort
            description="PRAZO"
            [column]="getPrazoSortColumn()"
            [current]="currentSort"
            (sort)="currentSort.next($event)"
          ></app-header-sort>
        </td>
        <td *ngIf="isOperador">
          <app-header-sort
            description="LOJISTA"
            [column]="'lojista.nome'"
            [current]="currentSort"
            (sort)="currentSort.next($event)"
          ></app-header-sort>
        </td>
        <td *ngIf="isOperador">
          <app-header-sort
            description="VENDEDOR"
            [column]="'vendedor.nome'"
            [current]="currentSort"
            (sort)="currentSort.next($event)"
          ></app-header-sort>
        </td>
        <td *ngIf="isLojista">
          <app-header-sort
            description="OPERADOR"
            column="nomeVendedor"
            [current]="currentSort"
            (sort)="currentSort.next($event)"
          ></app-header-sort>
        </td>
      </tr>
    </thead>

    <tbody class="table-body">
      <tr
        *ngFor="let proposta of propostas"
        class="table-row"
        [ngClass]="{ 'table-row-sos': proposta.totalSOS }"
      >
        <td>
          <div class="flex-container">
            <span
              [ngClass]="iconeProduto(proposta.product)"
              (click)="goToTimeline(proposta)"
            ></span>
            <span *ngIf="proposta.capturedEfetive" class="icon-omni-efetive-mais icon-pesados-brasil margin-left-12"></span>
            <span
              class="icon-pesados-brasil"
              [ngClass]="{
                'visibility-hidden':
                  tipoPropostaEnum.PROPRIA === proposta?.campaign?.type,
                'icon-recebido-pesados-brasil':
                  tipoPropostaEnum.RECEBIDA === proposta?.campaign?.type,
                'icon-indicado-pesados-brasil':
                  tipoPropostaEnum.INDICADA === proposta?.campaign?.type
              }"
              [tooltip]="popTemplate"
              triggers="click"
              placement="right"
              containerClass="tooltip"
              (click)="getDadosPesadosBrasil(proposta)"
            ></span>
          </div>
        </td>
        <td
          [innerHtml]="
            proposta?.totalSOS
              ? proposta?.status?.title + sosText
              : proposta?.status.title
          "
          (click)="goToTimeline(proposta)"
        ></td>
        <td (click)="goToTimeline(proposta)">{{ proposta?.id }}</td>
        <td (click)="goToTimeline(proposta)">
          <div>{{ proposta?.customer?.name }}</div>
          <div>{{  (proposta?.customer?.type === 'J') ? (proposta?.customer?.document | cnpj) : (proposta?.customer?.document | cpf) }}</div>
        </td>
        <td (click)="goToTimeline(proposta)">
          {{ proposta?.value | currency: 'BRL':'symbol' }}
        </td>
        <td (click)="goToTimeline(proposta)">{{ proposta?.analyst?.name }}</td>
        <td (click)="goToTimeline(proposta)">
          {{ proposta?.date | datetime }}
        </td>
        <td (click)="goToTimeline(proposta)">
          <ng-container *ngIf="idFase === 1 || idFase === 3">
            {{ proposta?.analyst?.time }} min
          </ng-container>
          <ng-container *ngIf="idFase === 2">
            {{
              proposta?.status?.approvedWithReservation ? 'Com alterações' : ''
            }}
          </ng-container>
          <ng-container *ngIf="idFase === 4">
            {{
              proposta?.status?.reasonRefuses
                ? proposta?.status?.reasonRefuses
                : ''
            }}
          </ng-container>
        </td>
        <td *ngIf="isOperador" (click)="goToTimeline(proposta)">
          {{ proposta?.store?.name }}
        </td>
        <td *ngIf="isOperador" (click)="goToTimeline(proposta)">
          {{ proposta?.store?.sellerName }}
        </td>
        <td
          *ngIf="isLojista"
          title="setupTdTitle(proposta.vendedor)"
          (click)="goToTimeline(proposta)"
        >
          {{ proposta?.store?.name }}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<app-modal-message
  #modalMessage
  [title]="'Atenção!'"
  [hideClose]="true"
></app-modal-message>

<ng-template #popTemplate>
  <app-loader-default
    text="Buscando informações da proposta"
    [show]="isBuscandoProposta"
    size="fa-1x"
  ></app-loader-default>
  {{ toolTip }}
</ng-template>
